export default __webpack_public_path__ + "media/img/filetypes/img-93f006a3f7dbad2025e49412fbb94e8b.svg";